import React from 'react'
import PropTypes from 'prop-types'
import { Bar } from 'recharts'
import { titlecase } from 'utils/strings'
import Loading from 'components/Loading'
import EmptyState from 'components/EmptyState'
import { DATE_RANGE } from 'containers/Reports/utils/date_helpers'
import * as dateHelpers from 'containers/Reports/utils/date_helpers'
import * as reportHelpers from 'containers/Reports/utils/report_helpers'
import Graph from 'containers/Reports/components/Graph'
import SpreadSheet from 'containers/Reports/components/SpreadSheet'
import UserHUD from 'containers/Reports/components/Graph/components/UserHUD'
import DateSelector from 'containers/Reports/components/Graph/components/DateSelector'
import { ReportContainer, EmptyContainer, GraphContainer } from 'containers/Reports/styles'
import { Satellite } from 'svg'
import theme from '../../../../../themes/light'

class RepliedReport extends React.Component {
  formatTableData = () => {
    const { repliedReports } = this.props
    const records = repliedReports.getIn(['data', 'records'])
    const users = repliedReports.getIn(['data', 'populate', 'users'])
    const sequences = repliedReports.getIn(['data', 'populate', 'campaigns'])

    const tableColumns = ['name', 'date', 'sentiment', 'user', 'sequence']
    const tableRows = []
    records
      .entrySeq()
      .forEach(record => {
      // date meeting was booked
        const repliedAt = record[1].get('replied_at')
        const repliedAtDateStr = dateHelpers.generateFormattedDateFromUTCString(repliedAt)

        // who we booked the meeting with
        const name = record[1].get('name')
        const contactID = record[1].get('_id')

        // who booked the meeting
        const sequence = sequences.getIn([record[1].get('_campaign'), 'title'])
        const sequenceID = sequences.getIn([record[1].get('_campaign'), '_id'])
        const user = users.getIn([record[1].get('_user'), 'full_name'])

        // stop users clicking into deleted contact from replied report
        const deleted = record[1].get('deleted')

        let sentiment = record[1].get('sentiment') || ''
        sentiment = sentiment
          .toLowerCase()
          .split('_')
          .join(' ')
        sentiment = titlecase(sentiment)

        // store the data into their reptective columns
        tableRows.push({
          date: repliedAtDateStr,
          unformattedDate: repliedAt,
          name,
          user,
          contactID,
          sequence,
          sequenceID,
          sentiment,
          deleted
        })
      })

    return { tableColumns, tableRows }
  }

  render () {
    const {
      router,
      repliedReports,
      setSelectedDateType,
      selectedDateRange
    } = this.props

    if (!!repliedReports && repliedReports.get('loading')) {
      return <Loading width='100%' />
    }

    let graphValues = null
    let userTotals = null
    let totalUnits = 0
    let tableData = null
    if (repliedReports &&
      !repliedReports.get('loading') &&
      repliedReports.get('data') &&
      repliedReports.get('data').size > 0) {
      ({ graphValues, userTotals, totalUnits } = reportHelpers.formatBarGraphData(repliedReports))
      tableData = this.formatTableData()
    }

    if (!graphValues || graphValues.length < 0) {
      return (
        <ReportContainer>
          <EmptyContainer>
            <EmptyState
              height='100%'
              mt='0'
              p='3rem'
              icon={<Satellite />}
              title='Nothing To Report'
              description="Looks like we don't have any data for the timeframe and filter you have selected"
            />
          </EmptyContainer>
        </ReportContainer>
      )
    }

    return (
      <ReportContainer>
        <GraphContainer>
          <DateSelector
            dayDateRangeUpdate={() => setSelectedDateType(DATE_RANGE.DAY)}
            weekDateRangeUpdate={() => setSelectedDateType(DATE_RANGE.WEEK)}
            selectedDateRange={selectedDateRange}
          />

          <Graph
            graphData={graphValues}
            unitLabel='reply'
            unitLabelPlural='replies'
            selectedDateRange={selectedDateRange}
          >
            <Bar dataKey='value' fill={theme.colors.blue} />
          </Graph>

          <UserHUD
            unitLabel='Reply'
            unitLabelPlural='Replies'
            userData={userTotals}
            totalUnits={totalUnits}
          />
        </GraphContainer>

        <SpreadSheet
          router={router}
          tableData={tableData}
        />
      </ReportContainer>
    )
  }
}

RepliedReport.propTypes = {
  router: PropTypes.object,
  graphMenuRef: PropTypes.object,
  repliedReports: PropTypes.object,
  selectedDateRange: PropTypes.string,
  setSelectedDateType: PropTypes.func
}

export default RepliedReport
